import LightBoxSetup from './modules/lightbox-setup';
import BadgeAnimation from './modules/badge-animation/badge-animation';
//import CourseIndexCollapse from './modules/courseindex-collapse';
import CohortReminder from './modules/cohort-reminder';
import XPProgressBar from './modules/xp/progress-bar';
import ScormOverride from './modules/scorm/scorm-override';
import ScormRenderInline from './modules/scorm/scorm-render-inline';
import ScormHijackData from './modules/scorm/scorm-hijack-data';
import ScormHideSlide from './modules/scorm/scorm-hide-slide';
import XPVideoTracking from './modules/xp/video-tracking';
import DisableUnlike from './modules/board/disable-unlike';
import BoardInjectMarkup from './modules/board/inject-markup';
import MarkAsDoneToDashboard from './modules/mark-as-done-to-dashboard';

document.addEventListener('DOMContentLoaded', () => {
  BadgeAnimation();
  LightBoxSetup();
  //CourseIndexCollapse();
  CohortReminder();
  XPProgressBar();
  ScormOverride();
  ScormRenderInline();
  ScormHijackData([
    (scormHijackParams) => {
      ScormHideSlide(scormHijackParams, -2);
    }
  ]);
  XPVideoTracking();

  //
  DisableUnlike();
  BoardInjectMarkup();

  MarkAsDoneToDashboard();
});
